import BroadcastSchedule from '../../components/LiveTV/BroadcastSchedule'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { schedule } from '../../graphqlDic'
import { graphql, compose } from 'react-apollo'

export default compose(
    graphql(schedule, {
        name: 'schedule',
        options: (props) => ({
            variables: {
                date: props.date,
                channel_id: props.channel_id
            }
        })
    })
)(withRouter(
    connect(
        null,
        null
    )(BroadcastSchedule)
));



// WEBPACK FOOTER //
// ./src/containers/LiveTV/BroadcastSchedule.js